/** App router base path, e.g. `/uat` when deployed under `/uat/`. */
export function appBasePath(): string {
  const base = import.meta.env.BASE_URL ?? '/';
  if (base === '/') return '';
  return base.endsWith('/') ? base.slice(0, -1) : base;
}

export function loginPath(): string {
  return `${appBasePath()}/login`;
}

export function isLoginPath(pathname = window.location.pathname): boolean {
  return pathname === loginPath() || pathname.endsWith('/login');
}
